export default __webpack_public_path__ + "i18n/translations/translation-it.f720a803.json";